module.exports = __webpack_public_path__ + "img/lilv.22323288.png";